import { Component } from '@theme/component';

let ratingLibrary;

function loadRatingLibrary() {
  if (!document.querySelector('link[href*="/rating-snippet/dist.css"]')) {
    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = 'https://widget.reviews.io/rating-snippet/dist.css';
    document.head.append(stylesheet);
  }
  if (typeof window.ratingSnippet === 'function') return Promise.resolve();
  if (ratingLibrary) return ratingLibrary;

  ratingLibrary = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[src*="/rating-snippet/dist.js"]');
    const script = existing || document.createElement('script');
    const loaded = () => {
      cleanup();
      resolve();
    };
    const failed = () => {
      cleanup();
      if (!existing) script.remove();
      reject(new Error('Reviews.io rating script could not be loaded.'));
    };
    const cleanup = () => {
      script.removeEventListener('load', loaded);
      script.removeEventListener('error', failed);
    };
    script.addEventListener('load', loaded, { once: true });
    script.addEventListener('error', failed, { once: true });
    if (!existing) {
      script.src = 'https://widget.reviews.io/rating-snippet/dist.js';
      script.async = true;
      document.head.append(script);
    }
  }).catch((error) => {
    ratingLibrary = undefined;
    throw error;
  });
  return ratingLibrary;
}

class ProductRatings extends Component {
  async connectedCallback() {
    super.connectedCallback();
    if (!this.dataset.store || this.initialized) return;
    try {
      await loadRatingLibrary();
      if (!this.isConnected || this.initialized) return;
      window.ratingSnippet(this.dataset.ratingClass, {
        store: this.dataset.store,
        mode: 'default',
        color: this.dataset.color,
        linebreak: false,
        text: this.dataset.text,
        singularText: this.dataset.text,
        lang: this.dataset.lang,
        usePolaris: true,
        showEmptyStars: false,
      });
      this.initialized = true;
    } catch (error) {
      console.warn('[Product ratings]', error);
    }
  }
}

if (!customElements.get('nc-product-ratings')) {
  customElements.define('nc-product-ratings', ProductRatings);
}
